<script setup>
import { ref } from 'vue'
import { Input } from '../../../../../../../resources/js/components/ui/input/index.js'
import { Label } from '../../../../../../../resources/js/components/ui/label/index.js'
import { Button } from '../../../../../../../resources/js/components/ui/button/index.js'

const emit = defineEmits(['submit'])

const recipient = ref('')
const subject = ref('')
const message = ref('')
const isSubmitting = ref(false)

const submitDispatch = async () => {
  if (!recipient.value || !message.value) return

  isSubmitting.value = true
  emit('submit', {
    recipient: recipient.value,
    subject: subject.value,
    message: message.value
  })
  isSubmitting.value = false
}
</script>

<template>
  <form class="grid gap-4" @submit.prevent="submitDispatch">
    <div class="text-sm font-medium text-muted-foreground">
      Customer Operation - Dispatch Message
    </div>

    <div class="grid gap-2">
      <Label for="dispatch-recipient">Recipient</Label>
      <Input
        id="dispatch-recipient"
        v-model="recipient"
        type="text"
        placeholder="e.g. +1 (555) 123-4567"
        autocomplete="tel"
      />
    </div>

    <div class="grid gap-2">
      <Label for="dispatch-subject">Subject</Label>
      <Input
        id="dispatch-subject"
        v-model="subject"
        type="text"
        placeholder="Optional subject"
      />
    </div>

    <div class="grid gap-2">
      <Label for="dispatch-message">Message</Label>
      <Input
        id="dispatch-message"
        v-model="message"
        type="text"
        placeholder="Write your message..."
      />
    </div>

    <Button type="submit" :loading="isSubmitting" :disabled="!recipient || !message">
      Send Message
    </Button>
  </form>
</template>

<style scoped>

</style>
